import { useTranslation } from "react-i18next";
import { SceneLayout } from "src/components/SceneLayout";
import { H2 } from "src/atoms/typography";

import CodeInput from "./components/CodeInput";

export default function EnterCode({ onChange, processing, code }) {
  const { t } = useTranslation();
  return (
    <SceneLayout
      centerProps={{ width: "320px" }}
      center={
        <>
          <H2 textAlign="center" mb="16px" color="highEmphasis">
            {t("pairing.manually.enterCode.heading")}
          </H2>
          <CodeInput code={code} onChange={onChange} processing={processing} />
        </>
      }
    />
  );
}
